const footerLinks = [
  { label: '电影', href: '#media' },
  { label: '电视剧', href: '#media' },
  { label: '综艺', href: '#media' },
  { label: '动漫', href: '#media' },
  { label: '排行榜', href: '#ranking' },
  { label: '客户端', href: '#app' },
  { label: '关于我们', href: '#about' },
  { label: '联系我们', href: '#contact' },
  { label: '常见问题', href: '#faq' },
  { label: '最新动态', href: '#updates' },
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-100 border-t border-secondary-200">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8">
            <div className="col-span-2 sm:col-span-1">
              <span className="text-xl font-bold font-heading text-primary-600">色影视</span>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                春色影视最新网址入口，高清免费电影电视剧全集在线观看平台，不缓冲流畅播放，最新影视资源每日更新。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-3">快速导航</h4>
              <div className="space-y-2">
                {footerLinks.slice(0, 5).map((link) => (
                  <a
                    key={link.label}
                    href={link.href}
                    className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-3">服务支持</h4>
              <div className="space-y-2">
                {footerLinks.slice(5).map((link) => (
                  <a
                    key={link.label}
                    href={link.href}
                    className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-3">合作伙伴</h4>
              <p className="text-xs text-foreground-400 leading-relaxed">
                诚邀各大影视内容平台与媒体合作方加入，共同打造优质观影生态。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-3">关注我们</h4>
              <div className="flex gap-3">
                <span className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-wechat-line"></i>
                </span>
                <span className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-weibo-line"></i>
                </span>
                <span className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-bilibili-line"></i>
                </span>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; 2026 色影视 - 春色影视最新网址入口。本站所有资源均来自互联网，仅供学习交流使用。
            </p>
            <p className="text-xs text-foreground-400">
              高清影视免费在线观看不卡顿
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}